<script setup>
import { computed, onMounted, ref } from "vue";
import { Doughnut } from "vue-chartjs";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  PointElement,
  LineElement,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  PointElement,
  LineElement,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
);

const props = defineProps({
  data: { type: Array, required: true, default: () => [] },
  title: String,
});

const labels = ["Pendente", "Atrasado", "Pago"];
const values = computed(() =>
  labels.map((label) => {
    const item = props.data.find((i) => i.monthly_payment_status === label);
    return item ? parseFloat(item.total_amount) : 0;
  })
);

const chartData = computed(() => ({
  labels: labels,
  datasets: [
    {
      label: props.title ?? "Pagamentos por estado",
      data: values.value,
      backgroundColor: ["#00D8FF", "#DD1B16", "#41B883"],
    },
  ],
}));

const chartOptions = {
  responsive: true,
  plugins: {
    legend: { display: true, position: "bottom" },
    title: {
      display: true,
      text: props.title ?? "Evolução de pagamentos por status",
    },
  },
};
</script>
<template>
  <Doughnut :data="chartData" :options="chartOptions" />
</template>
 